import styled from "styled-components"
import { useProTableOt } from "../../../utility/componentOt/controllers/ProtableOtController";
import ProtableOt from "../../../utility/componentOt/views/ProtableOt";

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from '../../../ui/input'
import { useState } from "react"
import { useItem } from '../../controllers/ItemController'
import { useLabel } from '../../controllers/LabelController'
import { Form, Radio, Button } from './../../../ui/ot'
import { useRef } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next"

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const LabelPrint = () => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.labelPrint."

    const [form] = Form.useForm();
    const actionRef = useRef()
    const [data, setData] = useState([])
    const [edit, setEdit] = useState(true)

    const {
        ItemData,
        getItemData
    } = useItem({
        onBefore: () => { },
        onFinish: () => { }
    })

    const columns = [
        {
            title: t(`${i18nPrefix }Subject`) + "/" + t(`${ i18nPrefix }Author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            render: (text, record, index) => {
                return (
                    <>
                        {record?.bib_title} / {record?.bib_author}
                    </>

                )
            }
        },
        {
            title: t(`${i18nPrefix}Item_type`),
            dataIndex: 'item_itype_description',
            key: 'bibitem_itemtype_description',
        },
        {
            title: t(`${i18nPrefix}Item_call_number`),
            dataIndex: 'item_call_number_source_code',
            key: 'item_call_number_source_code',
        },
        {
            title: t(`${i18nPrefix}barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`${i18nPrefix}Actions`),
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Button variant="outline"
                    onClick={() => {
                        setData(pre => [...pre, record])
                    }}
                >{t(`${i18nPrefix}New_Record`)}</Button>
            )
        },
        // {
        //     title: '選取',
        //     dataIndex: 'select',
        //     key: 'select',
        //     render: () => (
        //         <Checkbox />
        //     )
        // },
    ]


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    return (
        <MainContainer>
            {false && <ButtonGroup>
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >新增</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>標籤群組</DropdownMenuItem>
                        <DropdownMenuItem>佈局</DropdownMenuItem>
                        <DropdownMenuItem>標籤範本</DropdownMenuItem>
                        <DropdownMenuItem>影印機資訊</DropdownMenuItem>
                        <DropdownMenuItem>條碼範圍</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >管理</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>標籤群組</DropdownMenuItem>
                        <DropdownMenuItem>佈局</DropdownMenuItem>
                        <DropdownMenuItem>標籤範本</DropdownMenuItem>
                        <DropdownMenuItem>影印機資訊</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>}
            <Title>{t("library.backstage.LabelPrint.")}</Title>
            <WhiteBox>
                <ItemContainer>
                    <Form
                        form={form}
                        initialValues={{
                            mode: 'barcode',
                            numbers: ''
                        }}
                    >
                        {false ?
                            <Form.Item
                                name="description"
                                label={t(`${i18nPrefix}description`)}
                                wrapperCol={15}
                                labelCol={9}
                            >
                                <Input />
                            </Form.Item>
                            :
                            <></>
                        }
                        <Form.Item
                            name="mode"
                            label={t(`${i18nPrefix}mode`)}
                            wrapperCol={15}
                            labelCol={9}
                        >
                            <Radio.Group>
                                <Radio value="barcode">{t(`${i18nPrefix}barcode`)}</Radio>
                                <Radio value="itemnumber">{t(`${i18nPrefix}item_number`)}</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="numbers"
                            label={t(`${i18nPrefix}input_code`)}
                            wrapperCol={15}
                            labelCol={9}
                        >
                            <Input />
                        </Form.Item>
                        {/* <GrayText>每行一組編號</GrayText> */}
                        <Button type={'button'} onClick={() => actionRef.current.reloadAndRest()}>{t("search")}</Button>
                    </Form>
                </ItemContainer>
            </WhiteBox>
            <ProtableOt
                actionRef={actionRef}
                columns={columns}
                request={async (params = {}, sort, filter) => {
                    if (!form.getValues('numbers')) {
                        return {
                            data: [],
                            total: 0
                        }
                    }
                    // setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        // "categorycode": "TEST",
                    };
                    newParams = {
                        // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        [form.getValues('mode')]: form.getValues('numbers')
                    }
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    // setPageSize(params?.pageSize ?? 20)
                    return getItemData({
                        ...newParams
                    })
                }}
                rowSelection={false}
            />
            <LabelBatch edit={edit} data={data} setData={setData} />
        </MainContainer>
    )
}

const LabelBatch = ({
    edit = true,
    data = [],
    setData = () => { }
}) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.labelPrint."
    const actionRef = useRef()
    const dataRef = useRef([])
    const columns = [
        {
            title: t(`${i18nPrefix}lable_number`),
            dataIndex: 'lable_number',
            key: 'lable_number',
            render: (_, __, index) => <>{(index + 1)}</>
        },
        {
            title: t(`${i18nPrefix}Subject`) + "/" + t(`${i18nPrefix}Author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            render: (text, record, index) => {
                return (
                    <>
                        {record?.bib_title} / {record?.bib_author}
                    </>

                )
            }
        },
        {
            title: t(`${i18nPrefix}Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`${i18nPrefix}Item_call_number`),
            dataIndex: 'item_call_number_source_code',
            key: 'item_call_number_source_code',
        },
        {
            title: t(`${i18nPrefix}barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`${i18nPrefix}Actions`),
            dataIndex: 'action',
            key: 'action',
            render: (_, record, index) => (
                <Button variant="outline"
                    onClick={() => {
                        setData(pre => pre.filter((_, filterIndex) => filterIndex !== index))
                    }}
                >{t("delete")}</Button>
            )
        },
        // {
        //     title: '選取',
        //     dataIndex: 'select',
        //     key: 'select',
        //     render: () => (
        //         <Checkbox />
        //     )
        // },
    ]
    const [loadingPrint, setLoadingPrint] = useState(false)

    const onPrintLabel = () => {
        postLabelData(data.map(item => {
            return {
                text: item?.item_barcode,
                barcode: item?.item_barcode
            }
        }))
    }
    const request = async (data) => await new Promise((resolve, reject) => {
        console.log(dataRef.current)
        console.log(data)
        resolve({
            data: dataRef.current,
            total: dataRef.current.length
        })
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    const {
        postLabelData
    } = useLabel({
        onBefore: ({ axiosMode }) => {
            if (axiosMode === "post") {
                setLoadingPrint(true)
            }
        },
        onFinish: ({ axiosMode }) => {
            if (axiosMode === "post") {
                setLoadingPrint(false)
            }
        }
    })
    useEffect(() => {
        dataRef.current = data
        actionRef.current.reload()
    }, [data])

    return (
        <>
            {edit && <>
                <ButtonGroup>
                    {true ?
                        <>
                            <Button variant="outline" onClick={onPrintLabel} loading={loadingPrint}>{t(`${i18nPrefix}print_all`)}</Button>
                            {/* <Button variant="outline" >列印所選項目</Button> */}
                            <Button variant="outline" onClick={() => setData([])}>{t(`${i18nPrefix}clear_all`)}</Button>
                        </>
                        :
                        <>
                            <Button variant="outline" >新增項目</Button>
                            <Button variant="outline" >儲存描述</Button>
                            <Button variant="outline" >刪除選擇項目</Button>
                            <Button variant="outline" >刪除標籤群組</Button>
                            <Button variant="outline" >刪除副本</Button>
                            <Button variant="outline" >輸出選擇項目</Button>
                            <Button variant="outline" >輸出標籤群組</Button>
                        </>
                    }
                </ButtonGroup>
                <WhiteBox>
                    <ProtableOt
                        actionRef={actionRef}
                        columns={columns}
                        rowSelection={false}
                        request={() => request(data)}
                    />
                </WhiteBox>
            </>
            }
        </>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.div`
color: #929292;
width: 8em;
text-align: end;
padding-right: 1em;
`

const ItemTitle = styled.div`
color: #929292;
text-align: left;
font-size: 1.1em;
font-weight: 600;
`

const ItemContainer = styled.div`
width: fit-content;
`

const ItemBox = styled.div`
padding: 0.1em;
margin-left: 1em;
/* width: fit-content; */
// border-bottom: 1px solid #d4d4d4;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: center;
`

export default LabelPrint